import { render, staticRenderFns } from "./zhengzhuangteyixingfenxi.vue?vue&type=template&id=57441568&"
import script from "./zhengzhuangteyixingfenxi.vue?vue&type=script&lang=ts&"
export * from "./zhengzhuangteyixingfenxi.vue?vue&type=script&lang=ts&"
import style0 from "./zhengzhuangteyixingfenxi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports